/**
 * A dónde va alguien que acaba de entrar, si no venía de otro sitio.
 *
 * Estaba escrito tres veces —login, registro y el aterrizaje de Google— y
 * las tres TIENEN que coincidir: si el día que cambie el destino solo se
 * actualizan dos, quien entre con Google acabará en otra pantalla que
 * quien entre con su correo, y nada fallará para avisarlo.
 */
/*
 * "/shop", porque quien entra sin venir de ningún sitio es un CLIENTE:
 * el journey de compra (Anahí, 26-ago) trae a la gente del carrito al
 * login y de vuelta a la tienda.
 *
 * Era "/health", que ya ni siquiera existe como ruta — quien entraba
 * sin `from` aterrizaba en el 404.
 */
export const DEFAULT_DESTINATION = "/shop";

/**
 * A dónde va cada ROL al entrar sin venir de ningún sitio.
 *
 * Quien administra va a SU panel — mandarla a la tienda es entrar y que
 * no pase nada, que es la mala experiencia que Anahí señaló (26-ago).
 * El cliente va a la tienda, que hoy es su lugar; el día que exista el
 * panel de socio, este es el único renglón que cambia.
 */
export function destinationForRole(role: string | undefined): string {
  /*
   * Todos INICIAN COMO SOCIOS (Anahí, 27-ago): quien entra aterriza en
   * su panel de socio — su resumen, su enlace, sus puntos — no en la
   * tienda como un visitante más. Los administradores van al suyo.
   */
  return role === "super_admin" || role === "admin" ? "/admin" : "/socio";
}
